import React, { useState } from "react";
import { Box, Button, Card, IconButton, Modal, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { PRIMARY_ORANGE } from "./constants";

const DEFAULT_HEIGHT = 320;

const cardSx = {
  borderRadius: "12px",
  border: "1px solid #eee",
  boxShadow: "0 1px 4px rgba(0, 0, 0, 0.04)",
  overflow: "hidden",
};

const DetailImagePreview = ({
  imageUrl,
  alt = "Preview",
  title,
  emptyLabel = "No Image Available",
  height = DEFAULT_HEIGHT,
}) => {
  const [open, setOpen] = useState(false);
  const hasImage = imageUrl && imageUrl !== "null";

  if (!hasImage) {
    return (
      <Card
        sx={{
          ...cardSx,
          height,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "#fafafa",
        }}
      >
        <Typography color="text.secondary">{emptyLabel}</Typography>
      </Card>
    );
  }

  return (
    <>
      <Card sx={cardSx}>
        {title && (
          <Typography
            variant="caption"
            sx={{
              display: "block",
              p: 1,
              fontWeight: 600,
              color: "text.secondary",
              bgcolor: "#fafafa",
              borderBottom: "1px solid #eee",
            }}
          >
            {title}
          </Typography>
        )}
        <Box
          sx={{
            position: "relative",
            height,
            bgcolor: "#fafafa",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            component="img"
            src={imageUrl}
            alt={alt}
            sx={{
              width: "100%",
              height: "100%",
              display: "block",
              objectFit: "contain",
            }}
          />
          <Button
            size="small"
            variant="contained"
            startIcon={<VisibilityOutlinedIcon sx={{ fontSize: 16 }} />}
            onClick={() => setOpen(true)}
            sx={{
              position: "absolute",
              bottom: 12,
              right: 12,
              textTransform: "none",
              fontWeight: 600,
              bgcolor: PRIMARY_ORANGE,
              boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
              "&:hover": { bgcolor: "#f4511e", boxShadow: "0 2px 8px rgba(0,0,0,0.2)" },
            }}
          >
            View
          </Button>
        </Box>
      </Card>

      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90vw",
            maxWidth: 960,
            maxHeight: "90vh",
            bgcolor: "#fff",
            borderRadius: "12px",
            boxShadow: "0 12px 40px rgba(0,0,0,0.2)",
            outline: "none",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: 2,
              py: 1.25,
              borderBottom: "1px solid #eee",
            }}
          >
            <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
              {title || alt}
            </Typography>
            <IconButton size="small" onClick={() => setOpen(false)} aria-label="Close">
              <CloseIcon />
            </IconButton>
          </Box>
          <Box
            sx={{
              flex: 1,
              p: 2,
              bgcolor: "#fafafa",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "auto",
              minHeight: 0,
            }}
          >
            <Box
              component="img"
              src={imageUrl}
              alt={alt}
              sx={{
                maxWidth: "100%",
                maxHeight: "calc(90vh - 80px)",
                objectFit: "contain",
                display: "block",
              }}
            />
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default DetailImagePreview;
